import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    numero_documento: Yup.string().required('El número de documento es obligatorio'),
})

export default validationSchema